import { useState } from "react";
import PropTypes from "prop-types";
import ApacCcF5 from "../Figures/ApacCcF5";
import useAreaQuery from "../../../../hooks/useAreaQuery";

const ApacCcS7 = (props) => {
  const [selectedProductId, setSelectedProductId] = useState(1);

  const { areaData: data } = useAreaQuery(
    `/custom/apac/cc/figures/5/${props.regionalUnitId}/${selectedProductId}`
  );

  const handleProductChange = (productId) => {
    setSelectedProductId(productId);
  };

  return (
    <>
      <p>
        Patterns in the use of costed abortion &amp; PAC services would vary
        across regions. Use the dropdown to explore differences by method
        between the three scenarios in 2030.
      </p>

      <ApacCcF5
        regionalUnitName={props.regionalUnitName}
        productId={selectedProductId}
        data={data}
        onProductChange={handleProductChange}
      />
    </>
  );
};

ApacCcS7.propTypes = {
  regionalUnitId: PropTypes.number.isRequired,
  regionalUnitName: PropTypes.string.isRequired,
};

export default ApacCcS7;
